import { render, staticRenderFns } from "./BaseSearchInputBasic.vue?vue&type=template&id=a46b7d5e"
import script from "./BaseSearchInputBasic.vue?vue&type=script&lang=js"
export * from "./BaseSearchInputBasic.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchInputBasic.vue?vue&type=style&index=0&id=a46b7d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports